import React from 'react';
import styles from './index.module.css';
import modalStyles from '../ModalLayout/index.module.css';
import tagAnElementImg from './assets/tag-an-element.png';
import tagThePageImg from './assets/tag-the-page.png';
import recordAVideoImg from './assets/record-a-video.png';
import { translations } from '../strings';
import { X as Close } from 'lucide-react';
import { useCreateTaskState } from '../../../providers/CreateTask';
import { usePublicFeedbackState } from '../../../providers/PublicFeedback';
import cx from 'classnames';
import PoweredBy from '../CreateTaskModal/PoweredBy';

type Props = {};

const FeedbackType: React.FC<Props> = () => {
  const {
    onCreateTask,
    onCreateFullPageTask,
    onCreateRecording
  } = useCreateTaskState();
  const { cancel, locale, setFeedbackState } = usePublicFeedbackState();

  const strings = translations(locale);

  const isRecordingSupported = false;

  return (
    <div className={modalStyles.outerContainer}>
      <div className={modalStyles.modal}>
        <div
          className={cx(
            modalStyles.closeContainer,
            modalStyles.whiteBackground
          )}
          onClick={cancel}
        >
          <Close className={modalStyles.closeIcon} />
        </div>
        <div className={styles.content}>
          <div>
            <h2>{strings.option_title_text}</h2>
            <div
              className={styles.option}
              onClick={() => {
                onCreateTask();
                setFeedbackState('SELECTOR');
              }}
            >
              <div className={styles.optionContent}>
                <p>{strings.option_pin_text}</p>
                <img
                  src={tagAnElementImg}
                  width="120"
                  height="110"
                  alt="An image showing an element being tagged for feedback"
                />
              </div>
            </div>
            <div
              className={styles.option}
              onClick={() => {
                onCreateFullPageTask();
                setFeedbackState('TASK');
              }}
            >
              <div className={styles.optionContent}>
                <p>{strings.option_site_text}</p>
                <img
                  src={tagThePageImg}
                  width="120"
                  height="110"
                  alt="an image showing the entire page being tagged for feedback"
                />
              </div>
            </div>
            {isRecordingSupported && (
              <div className={styles.option} onClick={onCreateRecording}>
                <div className={styles.optionContent}>
                  <p>{strings.option_site_recording}</p>
                  <img
                    src={recordAVideoImg}
                    width="120"
                    height="110"
                    alt="an image of a screen recording"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <PoweredBy />
      </div>
    </div>
  );
};

export default FeedbackType;
